import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { environment } from 'src/environments/environment';
import {catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const { apiDte } = environment;

    if (req.url.includes(apiDte)) {

      const reqClonada = req.clone({
        headers: new HttpHeaders({
          Authorization: 'Basic cm9vdDpvOWltb3lheA=='
        })
      });

      return next.handle(reqClonada).pipe(
        catchError( this.manejoError )
      );
    }

    if (req.url.includes(':5000')) {
      return next.handle(req).pipe(
        catchError( this.manejoError )
      );
    }

    if (req.url.includes('firebasestorage')) {
      return next.handle(req).pipe(
        catchError( this.manejoError )
      );
    }

  }

  manejoError(error: HttpErrorResponse) {
    return throwError(error.message);
  }
}
